import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
function isQuotaError(storage, e) {
  return e instanceof DOMException && (e.code === 22 || e.code === 1014 || e.name === 'QuotaExceededError' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED') && storage.length !== 0;
}
export var StorageAPI = /*#__PURE__*/function () {
  function StorageAPI(storage) {
    _classCallCheck(this, StorageAPI);
    if (storage) {
      this.storage = storage;
    } else if (storage === null) {
      this.storage = null;
    } else {
      this.storage = typeof window !== 'undefined' ? window.localStorage : null;
    }
  }
  _createClass(StorageAPI, [{
    key: "get",
    value: function get(name) {
      if (!this.storage) {
        return null;
      }
      var key = "".concat(STORAGE_NAMESPACE, ":").concat(name);
      var value = this.storage.getItem(key);
      if (value === 'null' || value === 'undefined') {
        this.storage.removeItem(key);
        return null;
      }
      return value || null;
    }
  }, {
    key: "set",
    value: function set(name, value) {
      var quotaError = false;
      var error = null;
      if (this.storage) {
        var key = "".concat(STORAGE_NAMESPACE, ":").concat(name);
        if (value) {
          try {
            this.storage.setItem(key, value);
          } catch (e) {
            error = e instanceof Error ? e : new Error("".concat(e));
            quotaError = isQuotaError(this.storage, e);
          }
        } else {
          this.storage.removeItem(key);
        }
      }
      return {
        isQuotaError: quotaError,
        error: error
      };
    }
  }]);
  return StorageAPI;
}();
var STORAGE_NAMESPACE = 'graphiql';